import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Banner from "../../../component/Banner";
import Bannerimg from "../../../images/retail/retail-banner.webp";
import image1 from "../../../images/retail/retail1.webp";
import image2 from "../../../images/retail/retail2.webp";
import image3 from "../../../images/retail/retail3.webp";
import image4 from "../../../images/retail/retail4.webp";
import image5 from "../../../images/retail/retail5.webp";

const Retail = () => {
  const banner = {
    title: "Enhance Customer Experience & Satisfaction with Digital",
    image: Bannerimg,
  };
  const card = [
    {
      image: image1,
      title: "Digital Retail",
      description:
        "Cylon Technology’s digital retail services at the most basic level is a series of experiences that allow our esteemed consumers or clients to easily manoeuvre their buying processes quickly and easily from any platforms whether web or through mobile. We work on every element from the design of compelling Omni-channel retail customer proposition through a clear implementation roadmap and financial plan that helps our clients in comprehensive achievable solutions.",
      tagName: "Learn More",
      tagLink: "omni-channel-services-1",
    },
    {
      image: image2,
      title: "Supply Chain",
      description:
        "Our Supply Chain Services consists of key links such as Procurement, Configuration, Data Security, Recycling, Storage and IMAC. Cylon Technologies supply chain managers have expertise in designing networks for manufacturers and retailers to enable customer service goals at the least total costs. As such, our efficient supply chain solutions are helping organizations to be more competitive in the market place.",
      tagName: "Learn More",
      tagLink: "supply-chain-services",
    },
    {
      image: image3,
      title: "E- Commerce",
      description:
        "Cylon Technologies over the years has acknowledged itself as the one stop top rated e-Commerce Development Services Provider offering the best end-to-end functionality e-Commerce solutions.  We have a professional development team providing all the advanced technologies in the field of e-commerce that you might need to allow your businesses to grow.",
      tagName: "Learn More",
      tagLink: "ecommerce",
    },
    {
      image: image4,
      title: "Omni Channel Strategy",
      description:
        "Cylon Technologies Omnichannel retailing strategy combines offering solutions for both the physical and online commerce and e-tailing. Omnichannel supersedes the multichannel and includes channels such as physical locations, ecommerce, mobile applications and social media.",
      tagName: "Learn More",
      tagLink: "omni-channel-services",
    },
    {
      image: image5,
      title: "Customer Experience",
      description:
        "Customers want to be heard in this digital age and this universal truth spans across all industries and markets. Digital technology advancements have transformed the customer expectations making them seek rich, interactive and engaging digital experiences.",
      tagName: "Learn More",
      tagLink: "customerexperiencesolutions",
    },
  ];
  return (
    <>
      <>
        <Helmet>
          <title>
            Retail — Cylon Technologies – Big Data | Data Analytics | Digital
            Strategy
          </title>
        </Helmet>
        <Banner heading={banner.title} bannerimg={banner.image} />
        <section className="sec-padd page_content pb-5">
          <div className="container">
            <h2 className="heading2 text-center pb-4">Retail</h2>
            <p>
              Evolution is hitting the Retail industry, like never before.
              Customers today are vastly educated and more connected, globally.
              They need versatile shopping, customized administration and
              instant satisfaction. These progressions are offering ascent to a
              large group of developments around retailing, versatile
              applications, client information mining, responsive supply chains
              and other technologies. The way to building up business sector
              center and position in the Retail industry is to turn into a user
              friendly destination. Today’s retailers confront an inexorably
              aggressive commercial center, where customer steadfastness is hard
              to win and much harder to secure. Rivalry from supercenters and
              accommodation stores is on an ascent.
            </p>
            <p>
              The movement in customers’ state of mind toward healthier
              nourishment and the ascent of digitization has energized Health
              and Wellness as one of the most grounded development zones for
              some Retailers. Forte Retailers face expanded rivalry from more
              complex online retailers, upscale mass shippers and renewed retail
              chains with restrictive brands.
            </p>
            <div className="col-md-10 mx-auto">
              <div className="row g-md-5 g-4">
                {card.map((item, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="img_card">
                      <img src={item.image} alt="images" />
                      <h2 className="heading2">{item.title}</h2>
                      <p>{item.description}</p>

                      {item.tagName && item.tagLink && (
                        <div className="btn_spacet">
                          <a
                            href={item.tagLink}
                            className="btn_small outline_blue"
                          >
                            {item.tagName}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-center pt-5">
                <Link
                  to="/connect"
                  className="btn_custom blue_btn"
                  href="Inquire"
                >
                  Inquire
                </Link>
              </div>
            </div>
          </div>
        </section>
      </>
    </>
  );
};

export default Retail;
